import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { safeReturnTo } from '@/core/auth';
import { LoginPage } from '@/modules/identity/public';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(undefined),
    /** Abre direto no "Criar conta" (botão do cabeçalho público). */
    cadastro: z.boolean().optional().catch(undefined),
  }),
  // Já autenticado: volta para onde ia. `href`, não `to`, porque o destino
  // pode carregar query string (/cursos?tag=x). Vale também logo depois do
  // cadastro: a conta é criada, a pessoa entra e cai aqui.
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) throw redirect({ href: safeReturnTo(search.redirect), replace: true });
    // Sem redirect para fora no logout, o app continua vivo: o cache do
    // usuário anterior não pode sobreviver para o próximo nesta aba.
    context.queryClient.clear();
  },
  component: function LoginRoute() {
    const { cadastro, redirect } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <LoginPage
        mode={cadastro ? 'signup' : 'login'}
        // Trocar entre entrar e criar conta não empilha histórico: o "voltar"
        // do navegador continua levando para a página de origem.
        onModeChange={(mode) =>
          void navigate({
            search: (prev) => ({ ...prev, cadastro: mode === 'signup' || undefined }),
            replace: true,
          })
        }
        redirect={redirect}
      />
    );
  },
});
